(function(){
  'use strict';
  var root=document.getElementById('RevalEditorial');if(!root)return;
  root.querySelectorAll('[data-b04-brand-fallback]').forEach(function(form){
    var mode=form.getAttribute('data-b04-brand-fallback');
    var select=form.querySelector('[data-b04-brand-select]');
    if(!select)return;
    function keepSearchControls(searchForm){
      searchForm.querySelectorAll('[data-b04-search-control]').forEach(function(input){input.remove();});
      Array.from(new FormData(form).entries()).forEach(function(entry){
        var name=entry[0],value=entry[1];
        if(name.indexOf('filter.')!==0&&!(name==='sort_by'&&/^price-(ascending|descending)$/.test(value)))return;
        var input=document.createElement('input');input.type='hidden';input.name=name;input.value=value;input.dataset.b04SearchControl='';searchForm.appendChild(input);
      });
    }
    if(mode==='collection'){
      function restoreCollection(){
        select.value=location.pathname.endsWith('/vendors')?(new URL(location.href).searchParams.get('q')||''):'';
      }
      restoreCollection();
      window.addEventListener('pageshow',restoreCollection);
      form.addEventListener('submit',function(){form.action=select.value?form.dataset.vendorUrl:form.dataset.allUrl;});
      var catalogSearch=root.querySelector('.catalog-search');
      if(catalogSearch)catalogSearch.addEventListener('submit',function(){
        var input=catalogSearch.querySelector('[name="q"]');
        if(select.value&&input)input.value='vendor:"'+select.value+'"'+(input.value.trim()?' AND ('+input.value.trim()+')':'');
        keepSearchControls(catalogSearch);
      });
      return;
    }
    var terms=form.querySelector('[name="q"]');
    var original=terms.value,match=original.match(/^vendor:"([^"]+)"(?: AND \(([\s\S]*)\))?$/);
    var valid=match&&Array.from(select.options).some(function(o){return o.value===match[1];});
    var base=valid?(match[2]||''):original;
    if(valid)select.value=match[1];
    var searchForm=root.querySelector('.catalog-search');
    var searchInput=searchForm&&searchForm.querySelector('[name="q"]');
    if(searchInput)searchInput.value=base;
    window.addEventListener('pageshow',function(){
      var current=new URL(location.href).searchParams.get('q')||'';
      var m=current.match(/^vendor:"([^"]+)"(?: AND \(([\s\S]*)\))?$/);
      var known=m&&Array.from(select.options).some(function(o){return o.value===m[1];});
      if(searchInput)searchInput.value=known?(m[2]||''):current;
      terms.value=current;
      select.value=known?m[1]:'';
    });
    function query(text){var brand=select.value;return brand?'vendor:"'+brand+'"'+(text.trim()?' AND ('+text.trim()+')':''):text;}
    form.addEventListener('submit',function(){terms.value=query(searchInput?searchInput.value:base);});
    if(searchForm)searchForm.addEventListener('submit',function(){searchInput.value=query(searchInput.value);keepSearchControls(searchForm);});
  });
  root.querySelectorAll('.b04-brands').forEach(function(details){
    details.addEventListener('keydown',function(e){if(e.key==='Escape'){details.open=false;details.querySelector('summary').focus();}});
  });
})();
